<template>
    <!--begin::Menu-->
    <div class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px"
         data-kt-menu="true">
        <!--begin::Heading-->
        <div class="d-flex flex-column bgi-no-repeat rounded-top"
             :style="`background-image: url('${getAssetPath(
        '/media/misc/menu-header-bg.jpg'
      )}')`">
            <!--begin::Title-->
            <h3 class="text-white fw-semibold px-9 mt-10 mb-6">
                Thông báo <span class="fs-8 opacity-75 ps-3">{{totalUnRead}} thông báo chưa đọc</span>
            </h3>

            <!--end::Title-->
            <!--begin::Tabs-->
            <ul class="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-semibold px-9">
                <li class="nav-item">
                    <a class="nav-link text-white opacity-75 opacity-state-100 pb-4 active"
                       data-bs-toggle="tab"
                       href="#kt_topbar_notifications_1">Hồ sơ</a>
                </li>


                <!--<li class="nav-item">
                <a class="nav-link text-white opacity-75 opacity-state-100 pb-4"
                   data-bs-toggle="tab"
                   href="#kt_topbar_notifications_3">Logs</a>
            </li>-->
            </ul>
            <!--end::Tabs-->
        </div>
        <!--end::Heading-->
        <!--begin::Tab content-->
        <div  style="text-align:right; margin-bottom:0" v-if="totalUnRead > 0">
            <a @click="readAllNoti()" href="javascript:;" class="btn btn-color-gray-600 btn-active-color-primary">
                Đọc tất cả
            </a>
        </div>
        <div class="tab-content">
            <!--begin::Tab panel-->

            <div class="tab-pane fade show active" id="kt_topbar_notifications_1" role="tabpanel">
                <!--begin::Items-->
                <div class="scroll-y mh-325px px-8">
                    <template v-for="(item, index) in listNoti" :key="index">
                        <!--begin::Item-->
                        <div class="d-flex flex-stack py-4">
                            <!--begin::Section-->
                            <div class="d-flex align-items-center">
                                <!--begin::Symbol-->
                                <div class="symbol symbol-35px me-4">
                                    <span class="bg-light-primary symbol-label">
                                        <KTIcon icon-name="technology-2"
                                                icon-class="text-primary" />
                                    </span>
                                </div>
                                <!--end::Symbol-->
                                <!--begin::Title-->
                                <div class="mb-0 me-2">
                                    <a href="javascript:;" @click="readNoti(item)"
                                       :class="{'fs-6 text-gray-800 text-hover-primary':true,'fw-bold':item.isRead !=true && readAll == false}">{{ item.objectTitle }}</a>
                                    <div class="text-gray-500 fs-7">
                                        {{ item.message }}
                                    </div>
                                </div>
                                <!--end::Title-->
                            </div>
                            <!--end::Section-->
                            <!--begin::Label-->
                            <span class="badge badge-light fs-8">{{ formatDateTime(item.createdDate) }}</span>
                            <!--end::Label-->
                        </div>
                        <!--end::Item-->
                    </template>
                </div>
                <!--end::Items-->
                <!--begin::View more-->
                <div class="py-3 text-center border-top" v-if="totalRows > listNoti.length">
                    <a @click="readMore()" href="javascript:;" class="btn btn-color-gray-600 btn-active-color-primary">
                        Xem thông báo trước đó
                        <KTIcon icon-name="arrow-right" icon-class="fs-5" />
                    </a>
                </div>
                <!--end::View more-->
            </div>
            <!--end::Tab panel-->
            <!--begin::Tab panel-->
            <!--<div class="tab-pane fade" id="kt_topbar_notifications_3" role="tabpanel">-->
            <!--begin::Items-->
            <!--<div class="scroll-y mh-325px my-5 px-8">
        <template v-for="(item, index) in listNoti" :key="index">-->
            <!--begin::Item-->
            <!--<div class="d-flex flex-stack py-4">-->
            <!--begin::Section-->
            <!--<div class="d-flex align-items-center me-2">-->
            <!--begin::Code-->
            <!--<span class="w-70px badge me-4"
          :class="`badge-light-${item.state}`">{{ item.code }}</span>-->
            <!--end::Code-->
            <!--begin::Title-->
            <!--<a href="#"
        class="text-gray-800 text-hover-primary fw-semibold">{{ item.message }}</a>-->
            <!--end::Title-->
            <!--</div>-->
            <!--end::Section-->
            <!--begin::Label-->
            <!--<span class="badge badge-light fs-8">{{ item.time }}</span>-->
            <!--end::Label-->
            <!--</div>-->
            <!--end::Item-->
            <!--</template>
        </div>-->
            <!--end::Items-->
            <!--begin::View more-->
            <!--<div class="py-3 text-center border-top">
            <a href="#" class="btn btn-color-gray-600 btn-active-color-primary">
                View All
                <KTIcon icon-name="arrow-right" icon-class="fs-5" />
            </a>
        </div>-->
            <!--end::View more-->
            <!--</div>-->
            <!--end::Tab panel-->
        </div>
        <!--end::Tab content-->
    </div>
    <!--end::Menu-->
</template>

<script lang="ts">
    import { getAssetPath, getIllustrationsPath } from "@/core/helpers/assets";
    import { defineComponent } from "vue";
    import type { ListNotificationDto } from "~/core/services/ApiClient";
    import { formatDate, formatDateTime, formatNumber } from "~/core/helpers/util";
import type { Obj } from "@popperjs/core";
    export default defineComponent({
        name: "notifications-menu",
        components: {},
        setup() {
            const apiClient = useApiClient();
            const totalRows = ref(0);
            const listNoti = ref<ListNotificationDto[]>([]);
            const pageIndex = ref(1);
            const pageSize = ref(10);
            const readAll = ref(false);
            const totalUnRead = ref(0);
            const getListNoti = () => {
                apiClient
                    .getListNotification(pageIndex.value, pageSize.value)
                    .then((response) => {
                        listNoti.value = [...listNoti.value, ...response.data?.data];
                        totalRows.value = response.data?.totalRows ?? 0;
                    })
                    .catch(() => {
                       
                    });
            };
            const getNotiUnRead = () => {
                apiClient
                    .countNotificationUnRead()
                    .then((response) => {
                        totalUnRead.value = response.data?? 0;
                    })
                    .catch(() => {

                    });
            };
            const router = useRouter();
            const readNoti = (data: ListNotificationDto) => {
                if (!data.isRead) {
                    apiClient
                        .readNotification(data.id)
                        .then((res) => {
                            data.isRead = true;
                            if(totalUnRead.value > 0){
                                totalUnRead.value -= 1;
                            }
                            if(data.url){
                                router.push(data.url);
                            }else{
                                router.push(`/documents?id=${data.objectId}`);
                            }
                        })
                        .catch((err) => {
                            console.log("Read Noti error :", err);
                        });
                }else{
                    if(data.url){
                        router.push(data.url);
                    }else{
                        router.push(`/documents?id=${data.objectId}`);
                    }
                }
            }
            const readMore = () => {
                if (listNoti.value.length < totalRows.value) {
                    pageIndex.value += 1
                    getListNoti();
                }
            }
            const readAllNoti = () => {
                if (totalUnRead.value > 0) {
                    apiClient
                        .readAllNotification()
                        .then((res) => {
                            readAll.value = true;
                            totalUnRead.value = 0;
                            console.log("Read Noti", res);
                        })
                        .catch((err) => {
                            console.log("Read Noti error :", err);
                        });
                }
            }
            getListNoti();
            getNotiUnRead();
            return {
                formatDateTime,
                getAssetPath,
                listNoti,
                totalRows,
                pageIndex,
                pageSize,
                readNoti,
                readMore,
                totalUnRead,
                readAll,
                readAllNoti
            };
        },
    });
</script>
